export type PaginatedOffset<U> = {
  items: U[];
  count: number;
  offset: number;
  isLastPage: boolean;
};
